import api from './authService';

const BASE = '/user/two-factor';

export const getTwoFactorStatus = async () => {
  const response = await api.get(`${BASE}/status`);
  return response.data;
};

export const setupTwoFactor = async () => {
  const response = await api.post(`${BASE}/setup`);
  return response.data;
};

export const confirmTwoFactor = async (code) => {
  const response = await api.post(`${BASE}/confirm`, { code });
  return response.data;
};

export const cancelTwoFactorSetup = async () => {
  const response = await api.post(`${BASE}/cancel`);
  return response.data;
};

export const disableTwoFactor = async (payload = {}) => {
  const response = await api.post(`${BASE}/disable`, payload);
  return response.data;
};

export const regenerateTwoFactorRecoveryCodes = async (password) => {
  const response = await api.post(`${BASE}/recovery-codes`, { password });
  return response.data;
};
